// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Criteria, {getDefaultState as getCriteriaDefaultState} from './criteria';
import GridApi, {getDefaultState as getGridApiDefaultState} from './grid-api';
import Report, {getDefaultState as getReportDefaultState} from './report';
import SelectedDealers, {getDefaultState as getSelectedDealersDefaultState} from './selected-dealers';
import SelectedStatuses, {getDefaultState as getSelectedStatusesDefaultState} from './selected-statuses';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    criteria: Criteria,
    gridApi: GridApi,
    isPrintClaimDisabled: t.Boolean,
    report: Report,
    reportIsScrollable: t.Boolean,
    selectedDealers: SelectedDealers,
    selectedStatuses: SelectedStatuses,
    showNoResultsFound: t.Boolean,
    showSelectAll: t.Boolean
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        criteria: getCriteriaDefaultState(),
        gridApi: getGridApiDefaultState(),
        isPrintClaimDisabled: true,
        report: getReportDefaultState(),
        reportIsScrollable: false,
        selectedDealers: getSelectedDealersDefaultState(),
        selectedStatuses: getSelectedStatusesDefaultState(),
        showNoResultsFound: false,
        showSelectAll: true
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/state/index.js